<template>
    <div>
        <base-heading-secondary text="Availability for the last days"></base-heading-secondary>
        <base-loading-indicator-box v-if="incidentHistoryLoading" class="mt-6">
        </base-loading-indicator-box>
        <incident-history v-else :history="incidentHistory" class="mt-6"></incident-history>

        <div class="grid grid-cols-6 gap-6 mt-12">
            <div class="col-span-6 md:col-span-3 xl:col-span-4">
                <base-heading-secondary text="Detected Issues/Maintenance"></base-heading-secondary>
                <base-loading-indicator-box v-if="interruptionLoading" class="mt-6">
                </base-loading-indicator-box>
                <div v-else>
                    <incident-list-with-heading v-if="Object.keys(interruptionHistory).length > 0" :class="{'mt-6' : numericalIndex === 0, 'mt-4' : numericalIndex > 0}" :day="new Date(day)" :incidents="incident" v-for="(incident, day, numericalIndex) in interruptionHistory" :key="incident.id">
                    </incident-list-with-heading>

                    <base-card class="mt-6 text-gray-600 text-sm" v-if="Object.keys(interruptionHistory).length === 0">
                        There are no interruptions or maintenances in the past 🙌
                    </base-card>
                </div>
            </div>
            <div class="col-span-6 md:col-span-3 xl:col-span-2">
                <base-heading-secondary text="Scheduled Maintenance"></base-heading-secondary>
                <base-loading-indicator-box v-if="maintenanceLoading" class="mt-6">
                </base-loading-indicator-box>
                <div v-else>
                    <incident-card-list class="mt-6" :incidents="plannedMaintenance" v-if="plannedMaintenance.length">
                    </incident-card-list>
                    <base-card class="mt-6 text-gray-600 text-sm" v-else>
                        There is no planned maintenance for this host at this time. Everything seems fine. Have a nice day.
                    </base-card>
                </div>
            </div>
        </div>
        <rate-limit-exceeded-modal :open="rateLimitExceeded"></rate-limit-exceeded-modal>
    </div>
</template>

<script>
export default {
    props: {
        hostId: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            incidentHistoryLoading: true,
            incidentHistory: Array,
            interruptionLoading: true,
            interruptionHistory: Object,
            maintenanceLoading: true,
            plannedMaintenance: Array,
            rateLimitExceeded: false,
        }
    },
    methods: {
        handleRateLimit() {
            this.rateLimitExceeded = true;
        },
        fetchInterruptionHistory() {
            this.interruptionLoading = true;

            axios.get(route('api.interruption.list', {
                status: [
                    'ongoing',
                    'resolved',
                ],
                host: this.hostId,
                keyByDay: true,
                date: window.location.hash.substring(1),
            })).then(function (response) {
                this.interruptionHistory = response.data.interruptions;

                this.interruptionLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        fetchPlannedMaintenance() {
            this.maintenanceLoading = true;

            axios.get(route('api.interruption.list', {
                status: [
                    'planned',
                ],
                host: this.hostId,
            })).then(function (response) {
                this.plannedMaintenance = response.data.interruptions;

                this.maintenanceLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        fetchHistory() {
            this.incidentHistoryLoading = true;

            axios.get(route('api.host.history', { hostID: this.hostId })).then(function (response) {
                this.incidentHistory = response.data.history;

                this.incidentHistoryLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        refresh() {
            this.rateLimitExceeded = false;

            this.fetchInterruptionHistory();
            this.fetchPlannedMaintenance();
            this.fetchHistory();
        },
    },
    mounted() {
        this.$eventHub.$on('refresh', this.refresh);

        setTimeout(function () {
            this.refresh();
        }.bind(this), 1500);

        window.addEventListener('hashchange', function() {
            this.fetchInterruptionHistory();
        }.bind(this), false);
    },
}
</script>
